import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PointerDiv from "./PointerDiv";
import { faShoppingBasket } from "@fortawesome/free-solid-svg-icons";
import { useBasketContext } from "../../../../context/Basket/BasketContext";
import { useNavigate } from "react-router-dom";

const BasketButton = () => {
  const { basket } = useBasketContext();
  const navigate = useNavigate();

  const navigateToBasket = () => {
    if (basket?.lineItems?.length) navigate("/basket");
  };

  return (
    <PointerDiv
      showPointer={!basket?.lineItems?.length}
      onClick={navigateToBasket}
      className="pe-auto d-flex flex-row align-items-center gap-1 mb-1 px-1"
    >
      <FontAwesomeIcon icon={faShoppingBasket} color="white" size="lg" />
      <span className="mt-1 mr-2 text-white">
        Basket ({basket?.lineItems?.length ?? 0})
      </span>
    </PointerDiv>
  );
};

export default BasketButton;
